<template>
  <div>
    <configure-bookmark-folder-row
      :folder="folder"
    />
    <draggable v-model="folder.sortedBookmarkLinks" group="bookmarks" v-bind="VueDraggableDefinition.getOptions()"  @change="persistBookmarkLinkMove">
      <configure-bookmark-link-row
        v-for="link in folder.sortedBookmarkLinks"
        :key="link.id"
        :link="link"
        :folder="folder"
      />
    </draggable>
    <row>
      <column class="row-title">
        <button class="btn-link" @click="addLinkClicked">+ Add Link</button>
      </column>
    </row>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import {ConfigureSidebarModes} from "../../enums/configureSidebarModes";
  import ConfigureBookmarkFolderRow from './configure-bookmark-folder-row.vue';
  import ConfigureBookmarkLinkRow from './configure-bookmark-link-row.vue';
  import BookmarkMenuStoreMixinFactory from '../../mixins/bookmarkMenuStoreMixinFactory';
  import BookmarkFolder from "../../models/bookmarkFolder";
  import BookmarkLink from "../../models/bookmarkLink";
  import VueDraggableDefinition from "../../../../common/vue/vueDraggableDefinition";
  import Draggable from 'vuedraggable';
  import configureSidebarInterfaceStoreMixin from "../../mixins/configureSidebarInterfaceStoreMixin";

  const bookmarkMenuStoreMixin = BookmarkMenuStoreMixinFactory({
    actions: [
      'updateBookmarkLink',
      'changeBookmarkLinkParent',
    ],
  });

  export default Vue.extend({
    mixins: [bookmarkMenuStoreMixin, configureSidebarInterfaceStoreMixin],
    components: {
      ConfigureBookmarkFolderRow,
      ConfigureBookmarkLinkRow,
      Draggable,
    },
    props: {
      folder: {
        type: Object as () => BookmarkFolder,
        required: true
      },
      sidebarMode: {},
    },
    data: function(): object {
      return {
        ConfigureSidebarModes,
        VueDraggableDefinition,
      };
    },
    methods: {
      isActiveMode(targetMode: ConfigureSidebarModes): boolean {
        return this.sidebarMode === targetMode;
      },
      persistBookmarkLinkMove(evt) {
        if (evt.moved) {
          const bookmarkLink = evt.moved.element;
          this.updateBookmarkLink({bookmarkLink});
        } else if (evt.added) {
          const bookmarkLink = evt.added.element;
          this.changeBookmarkLinkParent({bookmarkLink, newBookmarkFolder: this.folder});
        }
      },
      addLinkClicked() {
        this.setInterfaceMode({mode: ConfigureSidebarModes.newLink, selected: this.folder});
      }
    },
  });
</script>
